import angular from 'angular';
import uiRouter from 'angular-ui-router';

import ActivationHourServicesComponent from './activationHourServices.component';
import HoursToMillisDirective from './hoursToMillis';
import MinutesToMillisDirective from './minutesToMillis';

const activationHourServicesModule = angular
  .module('tinaba.common.components.activationHourServices.activationHourServices',
    [uiRouter]
  )
  .component('activationHourServices', ActivationHourServicesComponent)
  .directive('hoursToMillisDirective', HoursToMillisDirective)
  .directive('minutesToMillisDirective', MinutesToMillisDirective);

export default activationHourServicesModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/activationHourServices/activationHourServices.js
 **/